import { CaretDownIcon } from "@phosphor-icons/react/dist/csr/CaretDown";
import { Button } from "@volca/ui/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@volca/ui/components/ui/dropdown-menu";
import { cn } from "@volca/ui/lib/utils";
import type { FindingFilter } from "./types";
import { REVIEW_FILTERS } from "./use-review-queue";

/** Show the current queue's count; the other modes live in its menu. */
export const ReviewFilters = ({
  value,
  onChange,
  countOf,
  countsReady,
}: {
  value: FindingFilter;
  onChange: (value: FindingFilter) => void;
  countOf: (value: FindingFilter) => number;
  countsReady: boolean;
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger
      render={
        <Button
          variant="ghost"
          size="sm"
          className="-ms-2"
          aria-label={`Finding status: ${REVIEW_FILTERS.find((item) => item.value === value)?.label}`}
        />
      }
    >
      <span
        className={cn("min-w-[3ch] tabular-nums", { invisible: !countsReady })}
      >
        {countsReady ? countOf(value).toLocaleString() : 0}
      </span>
      {REVIEW_FILTERS.find((item) => item.value === value)?.label}
      <CaretDownIcon aria-hidden />
    </DropdownMenuTrigger>
    <DropdownMenuContent
      align="start"
      className="min-w-44 pointer-coarse:[&_[role^=menuitem]]:min-h-11"
    >
      <DropdownMenuRadioGroup
        value={value}
        onValueChange={(picked) => {
          const option = REVIEW_FILTERS.find((item) => item.value === picked);
          if (option) onChange(option.value);
        }}
      >
        {REVIEW_FILTERS.map((item) => (
          <DropdownMenuRadioItem key={item.value} value={item.value}>
            <span className="flex-1">{item.label}</span>
            <span
              className={cn("text-subtle tabular-nums", {
                invisible: !countsReady,
              })}
            >
              {countsReady ? countOf(item.value).toLocaleString() : 0}
            </span>
          </DropdownMenuRadioItem>
        ))}
      </DropdownMenuRadioGroup>
    </DropdownMenuContent>
  </DropdownMenu>
);
